import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@monaco-editor/react';
import { Box } from '@mui/material';

const FormulaField = ({ value, onChange, disabled, maxHeight = 300 }) => {
  const [internalHeight, setInternalHeight] = useState(20);

  const containerRef = useRef();

  const handleMount = useCallback(
    editor => {
      editor.onDidContentSizeChange(sizeData => {
        const height = Math.min(maxHeight, sizeData.contentHeight);
        setInternalHeight(height);
        editor.layout({ width: containerRef.current.clientWidth, height });
      });
    },
    [maxHeight]
  );

  return (
    <Box height={internalHeight} ref={containerRef}>
      <Editor
        language='formula'
        theme='formula-theme'
        value={value}
        onChange={onChange}
        onMount={handleMount}
        options={{
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          overviewRulerLanes: 0,
          wordWrap: 'on',
          wrappingStrategy: 'advanced',
          readOnly: disabled,
          scrollbar: { vertical: 'auto', verticalScrollbarSize: 5, horizontal: 'hidden' }
        }}
      />
    </Box>
  );
};

FormulaField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  maxHeight: PropTypes.number
};

export default FormulaField;
